import {
  buildCliModalLoadedEvent,
  buildCliModalCtaClickEvent,
  GET_STARTED_WIX_CLI_MODAL_NAME,
  CLI_APP_OPTIONS_MODAL_ROUTE,
} from '@wix/dev-center-pages-common';
import { useBiLogger } from '../context/BiContext';

export const useGetStartedWixCliModalBi = () => {
  const { logger } = useBiLogger();

  const reportModalLoaded = () =>
    void logger.report(
      buildCliModalLoadedEvent({
        modalName: GET_STARTED_WIX_CLI_MODAL_NAME,
        route: CLI_APP_OPTIONS_MODAL_ROUTE.TEMPLATES,
      }),
    );

  const reportCtaClicked = (ctaName: string, toUrl?: string) =>
    void logger.report(
      buildCliModalCtaClickEvent({
        modalName: GET_STARTED_WIX_CLI_MODAL_NAME,
        route: CLI_APP_OPTIONS_MODAL_ROUTE.TEMPLATES,
        ctaName,
        toUrl,
      }),
    );

  return { reportModalLoaded, reportCtaClicked };
};
